module.exports = __webpack_public_path__ + "static/bgApp-fcba9a3375eb790eb6cc682fa6f68eb0.mp4";